<template>
  <div class="text-[15px]">
    <div v-if="props.curr !== ''">
      <div v-if="props.label">Current</div>
      <div
        :class="[
          'text-nowrap flex items-center gap-2',
          props.best && typeof props.curr === 'number'
            ? `${
                props.curr > props.best ? 'text-danger-100' : 'text-success-100'
              }`
            : '',
        ]"
      >
        {{
          typeof props.curr === "number" ? props.curr.toFixed(2) : props.curr
        }}
        <template
          v-if="
            props.best &&
            typeof props.curr === 'number' &&
            props.curr > props.best
          "
        >
          <ArrowDown :size="18" :stroke-width="2" />
          {{ (props.curr - props.best).toFixed(2) }}
        </template>
      </div>
    </div>
    <div class="flex items-center gap-2" v-if="props.comp !== ''">
      <div>Competitors</div>
      <div>
        {{
          typeof props.comp === "number" ? props.comp.toFixed(2) : props.comp
        }}
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { ArrowDown } from "lucide-vue-next";

type Props = {
  curr?: number | string;
  comp?: number | string;
  best?: number;
  label?: boolean;
};
const props = withDefaults(defineProps<Props>(), {
  curr: "",
  comp: "",
  best: undefined,
  label: true,
});
</script>
